import { PageContent } from '@src/components/PageContent/PageContent';
import type { ContainerWidth, ContainerPad } from '@src/components/Container/Container';
import { Shell, type ShellProps } from '@src/components/Shell/Shell';
import './BoxShell.css';

export interface BoxShellProps extends ShellProps {
  /** Defaults to full — box dashboards and pickers that need room. */
  width?: ContainerWidth;
  testId?: string;
  pad?: ContainerPad;
}

/**
 * Standard app header and footer with the shared Page landscape behind the body.
 * Quick-draw organizer dashboards, name selection, and participant cards use
 * this — not CreationShell.
 */
export function BoxShell({ children, width = 'full', pad = 'box', testId, ...shellProps }: BoxShellProps) {
  return (
    <Shell {...shellProps}>
      <PageContent pad={pad} width={width} className="box-shell__main" testId={testId}>
        {children}
      </PageContent>
    </Shell>
  );
}
